<style lang="scss">
.quotations-table {
  td {
    text-align: center;
    padding: 0;

    &.first-column {
      text-align: left;
      padding-left: 3rem;
    }

    div {
      &.centered {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;

        &--row {
          flex-direction: row;
        }
      }
    }
  }

  tbody {
    tr:last-of-type {
      td {
        border-bottom-width: 0;
      }
    }
  }

  .flag-icon {
    width: 8rem;
    border-radius: 0.5rem;
  }

  .country-date {
    min-height: 4rem;
  }
}
</style>

<template>
  <v-home-slide
    :loading="loading"
  >
    <table
      v-if="hasData"
      class="quotations-table table table--stripe h-full"
    >
      <tbody>
        <tr>
          <td
            class="first-column w-1/6"
          >
            <div class="h-full flex flex-col justify-center text-text2">
              <h2>EUR/mt</h2>
              <h3>WOW</h3>
            </div>
          </td>
          <td
            v-for="country in countries"
            :key="country.name"
          >
            <div class="centered">
              <div class="flex flex-row justify-center items-center">
                <img
                  :src="flagAsset(getFlagCode(country))"
                  class="flag-icon mr-4"
                >
                <h1>{{ formatCountryName(country.name) }}</h1>
              </div>
              <h2 class="mt-5 text-grey-darkest country-date">
                {{ countryDate(country.name) }}
              </h2>
            </div>
          </td>
        </tr>
        <tr
          v-for="data in apiData"
          :key="data.product.slug"
        >
          <td class="first-column">
            <div class="h-full flex flex-col justify-center">
              <h1>{{ formatProductName(data.product.name) }}</h1>
            </div>
          </td>
          <td
            v-for="countryData in data.data"
            :key="countryData.country.name"
          >
            <price-cell
              :price-data="countryData.data"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </v-home-slide>
</template>

<script>
import {LoadsDataMixin} from '@/mixins/LoadsDataMixin';
import PriceCell from './PriceCell';
import {flagAsset} from '@/helpers';
import moment from 'moment';

export default {
  name: 'Quotations',
  components: {
    PriceCell,
  },
  mixins: [
    LoadsDataMixin,
  ],
  data() {
    return {
      apiData: [],
    };
  },
  computed: {
    hasData() {
      return this.apiData.length > 0;
    },
    countries() {
      if (!this.hasData) {
        return [];
      }

      return this.apiData[0].data.map((data) => data.country);
    },
  },
  methods: {
    async loadData() {
      const { data } = await this.$api.get('quotations').get(this.createCancelTokenOption());
      this.apiData = data;
    },
    flagAsset,
    getFlagCode(country) {
      if (country.name ===  'EU_VPI') {
        return 'VPI-3';
      }
      return country.code;
    },
    formatCountryName(countryName) {
      if (countryName === 'EU_VPI') {
        return 'EU';
      }
      return countryName;
    },
    formatProductName(productName) {
      return productName.replace(' (Food)', '').replace(' (Feed)', '-Fe');
    },
    countryDate(countryName) {
      if (!this.hasData) {
        return '';
      }

      if (countryName === 'EEX') {
        return '';
      }

      const dates = this.apiData.map((data) => {
        const countryData = data.data.find((productData) => {
          return productData.country.name === countryName;
        });

        if (countryData.data === null) {
          return null;
        }

        return countryData.data.date;
      }).filter(Boolean);

      const date = dates.reduce((selectedDate, date) => {
        const momentDate = moment(date);
        if (selectedDate === null) {
          return momentDate;
        }

        if (momentDate.isBefore(selectedDate)) {
          return momentDate;
        }

        return selectedDate;
      }, null);

      return date.format('D MMM');
    },
  },
};
</script>
